
export default {
  props: {
    suggestion: {type: [String, Object], required: true}
  },
  emits: ['ask-ai'],
  data() {
    return {
      hover: false
    }
  },
  computed: {
    string() {
      return typeof this.suggestion === 'string' 
    },
    text(){
      if (this.string) return this.suggestion
      return this.suggestion.text
    }
  },
}
